var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":_vm.size,"variant":_vm.confirm ? 'danger' : 'outline-danger'},on:{"click":function($event){return _vm.remove()}}},[_vm._v(_vm._s(_vm.confirm ? 'Confirm?' : 'Remove'))])}
var staticRenderFns = []

export { render, staticRenderFns }